import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import HeroSection from '../components/HeroSection';
import ProductCard from '../components/ProductCard';
import { Product } from '../types';
import { getProducts } from '../services/api';
import { getFeaturedProducts } from '../data/products';
import { HiOutlineTruck, HiOutlineRefresh, HiOutlineShieldCheck, HiOutlineSupport } from 'react-icons/hi';

const Home: React.FC = () => {
  const [featured, setFeatured] = useState<Product[]>(getFeaturedProducts());

  useEffect(() => {
    getProducts({ featured: 'true' })
      .then(res => {
        if (res.data.results && res.data.results.length > 0) {
          setFeatured(res.data.results);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <div className="home">
      <HeroSection />

      <section className="features-bar">
        <div className="feature">
          <HiOutlineTruck size={28} />
          <div>
            <h4>Nationwide Delivery</h4>
            <p>We deliver to your doorstep</p>
          </div>
        </div>
        <div className="feature">
          <HiOutlineRefresh size={28} />
          <div>
            <h4>Easy Returns</h4>
            <p>30-day return policy</p>
          </div>
        </div>
        <div className="feature">
          <HiOutlineShieldCheck size={28} />
          <div>
            <h4>Secure Payment</h4>
            <p>100% secure checkout</p>
          </div>
        </div>
        <div className="feature">
          <HiOutlineSupport size={28} />
          <div>
            <h4>24/7 Support</h4>
            <p>We're here to help</p>
          </div>
        </div>
      </section>

      <section className="section featured-section">
        <div className="section-header">
          <h2>Featured Pieces</h2>
          <p>Handcrafted styles from our latest collection</p>
        </div>
        <div className="product-grid">
          {featured.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
        <div className="section-cta">
          <Link to="/shop" className="btn btn-outline">View All Pieces</Link>
        </div>
      </section>

      <section className="promo-banner">
        <div className="promo-content">
          <p className="promo-label">Handmade With Love</p>
          <h2>Every Stitch Tells a Story</h2>
          <p>Each YIBE piece is designed and sewn by hand, making every garment as unique as you are</p>
          <Link to="/shop" className="btn btn-primary">Shop Now</Link>
        </div>
      </section>

      <section className="section categories-section">
        <div className="section-header">
          <h2>Shop by Category</h2>
        </div>
        <div className="category-grid">
          <Link to="/shop?category=dresses" className="category-card">
            <img src="/images/IMG_1370.jpg" alt="Dresses" />
            <div className="category-card-overlay">
              <h3>Dresses</h3>
              <span>Shop Now</span>
            </div>
          </Link>
          <Link to="/shop?category=sets" className="category-card">
            <img src="/images/IMG_1386.jpg" alt="Sets" />
            <div className="category-card-overlay">
              <h3>Sets</h3>
              <span>Shop Now</span>
            </div>
          </Link>
          <Link to="/shop?category=gowns" className="category-card">
            <img src="/images/IMG_1392.jpg" alt="Gowns" />
            <div className="category-card-overlay">
              <h3>Gowns</h3>
              <span>Shop Now</span>
            </div>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
